export default "__VITE_ASSET__uqzoIA6g__"